import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ITopic } from 'app/shared/model/topic.model';
import { getEntities as getTopics } from 'app/entities/topic/topic.reducer';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { Container, Row, Col, Button, Label, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { JhiItemCount, JhiPagination, Translate, getSortState, logDebug } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { deleteEntity, getEntities, getEntity, getEntityannouncement } from './announcement.reducer';
import AnnouncementUpdate from './announcements-update';
import ReadMoreText from 'app/shared/common-fun/ReadMoreText';

const AnnouncementPage: React.FC = () => {
  const account = useAppSelector(state => state.authentication.account);
  const [selectedAnnouncementId, setSelectedAnnouncementId] = useState(null);
  const [announcementData, setAnnouncementData] = useState([]);
  const loading = useAppSelector(state => state.announcement.loading);
  const [showView, setShowView] = useState('list');
  const baseImageUrl = '/image';
  const announcementList = useAppSelector(state => state.announcement.entities);
  const dispatch = useAppDispatch();
  const id = account.id;
  const navigate = useNavigate();
  const totalItems = useAppSelector(state => state.announcement.totalItems);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, 20, 'id', 'desc'), location.search)
  );

  useEffect(() => {
    if (account) {
      dispatch(
        getEntityannouncement({
          id: account.id,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: 'id,desc',
        })
      );
    }
  }, [account, paginationState]);
  useEffect(() => {
    setAnnouncementData(announcementList);
  }, [announcementList]);

  const handleSubmit = async () => {
    await dispatch(
      getEntityannouncement({
        id: account.id,
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: 'id,desc',
      })
    );
    setShowView('list');
  };
  const deleteAnnouncement = async id => {
    await dispatch(deleteEntity(id));
    await dispatch(
      getEntityannouncement({
        id: account.id,
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: 'id,desc',
      })
    );
    // setNewsFeedData(newsFeedList);
  };
  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  function formatDate(dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (inputDate >= currentDate) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };

      return 'Today ' + inputDate.toLocaleTimeString('en-US', options as Intl.DateTimeFormatOptions);
    } else {
      const oneDayAgo = new Date(inputDate);
      oneDayAgo.setUTCDate(inputDate.getUTCDate() - 1);

      const options = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };

      return oneDayAgo.toLocaleString('en-US', options as Intl.DateTimeFormatOptions);
    }
  }
  return (
    <Container className="news-page card meeting-border">
      {showView == 'edit' && <AnnouncementUpdate inspirationId={selectedAnnouncementId} handleSubmit={handleSubmit} />}
      {showView == 'add' && <AnnouncementUpdate inspirationId={selectedAnnouncementId} handleSubmit={handleSubmit} />}
      {loading ? (
        <Spinner className="body-loader-icon"></Spinner>
      ) : (
        <>
          <Row className="page-header">
            <Col md="6" className="heading">
              <h1>Announcements</h1>
            </Col>
            <Col md="6" className="add-btn">
              {showView !== 'add' && (
                <div className="news-add-btn">
                  <FontAwesomeIcon icon="plus" />
                  &nbsp;
                  <Label
                    className="add-new-btn"
                    onClick={() => {
                      setShowView('add');
                      setSelectedAnnouncementId(null);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    Add new Announcement
                  </Label>
                </div>
              )}
            </Col>
          </Row>
          <Row className="news-list">
            {account ? (
              Array.isArray(announcementData) && announcementData.length > 0 ? (
                announcementData.map(announcement => (
                  <Col md="4" key={announcement.id} className="d-flex">
                    <div className="news-item w-100 d-flex flex-column">
                      <ReadMoreText
                        text={announcement.description}
                        maxLength={100}
                        onReadMore={() => {
                          setShowView('edit');
                          setSelectedAnnouncementId(announcement.id);
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                      />
                      <div className="news-topic">{announcement.topics}</div>

                      <Col md={12} className="news-img">
                        {announcement?.imageName ? (
                          announcement.imageName.endsWith('.mp4') ? (
                            <video controls className="mb-4 p-0">
                              <source src={`${baseImageUrl}/${announcement.imageName}`} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <img className="img-thumbnail mb-4 p-0" src={`${baseImageUrl}/${announcement.imageName}`} alt="Image" />
                          )
                        ) : null}
                      </Col>
                      <div className="news-link">
                        <a href={`${announcement.link}`}>{announcement.link}</a>
                      </div>
                      <div className="news-footer">
                        <div className="news-time">{formatDate(announcement.createdDate)}</div>
                        <div className="news-actions">
                          <Button
                            onClick={() => {
                              setShowView('edit');
                              setSelectedAnnouncementId(announcement.id);
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }}
                            color="primary"
                            size="sm"
                            data-cy="entityEditButton"
                          >
                            <FontAwesomeIcon icon="pencil-alt" />
                          </Button>
                          <Button className="news-dlt-btn" onClick={() => deleteAnnouncement(announcement.id)}>
                            <FontAwesomeIcon icon="trash" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <div className="connection-tab-gif">
                  <Row>
                    <div className="col-md-6">
                      {/* <h4>Build Your Professional Network</h4> */}
                      <p>
                        Welcome to the Announcements section your space to keep users informed! Use this area to share important updates
                        about the platform, including feature launches, maintenance schedules, policy changes, or any news users need to
                        know. Regularly posting here helps keep everyone on the same page and enhances the user experience. Stay consistent
                        and clear – your communication keeps our community connected!
                      </p>
                    </div>
                    <div className="col-md-6">
                      <img src="content/images/news_feed.png" />
                    </div>
                  </Row>
                </div>
              )
            ) : (
              <Spinner color="primary" />
            )}
          </Row>
          {totalItems ? (
            <div className={announcementData && announcementData.length > 0 ? '' : 'd-none'}>
              <div className="justify-content-center d-flex">
                <JhiItemCount
                  page={paginationState.activePage}
                  total={totalItems}
                  itemsPerPage={paginationState.itemsPerPage}
                  i18nEnabled
                />
              </div>
              <div className="justify-content-center d-flex">
                <JhiPagination
                  activePage={paginationState.activePage}
                  onSelect={handlePagination}
                  maxButtons={5}
                  itemsPerPage={paginationState.itemsPerPage}
                  totalItems={totalItems}
                />
              </div>
            </div>
          ) : (
            ''
          )}
        </>
      )}
    </Container>
  );
};

export default AnnouncementPage;
